import React from "react";
import { useTranslation } from "react-i18next";
const LangageSwitcher = () => {
  const { i18n } = useTranslation();
  const [selectedLng, setSelection] = React.useState("fr");

  const ulStyles = {
    padding: "0px",
  };

  return (
    <div className="langage-switcher">
      <ul style={ulStyles}>
        <li>
          <button
            className={
              selectedLng === "fr" ? "lng-button-active" : "lng-button"
            }
            onClick={() => {
              setSelection("fr");
              i18n.changeLanguage("fr");
            }}
          >
            FR
          </button>
          <span className="sr-only">FR : version française</span>
        </li>
        <li>
          <div className="lng-separator">
            <span>-</span>
          </div>
        </li>
        <li>
          <button
            className={
              selectedLng === "en" ? "lng-button-active" : "lng-button"
            }
            onClick={() => {
              setSelection("en");
              i18n.changeLanguage("en");
            }}
          >
            EN
          </button>
          <span className="sr-only">EN : english version</span>
        </li>
      </ul>
    </div>
  );
};

export default LangageSwitcher;
